export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-gradient-to-br from-primary-500 to-primary-700 rounded-2xl p-8 md:p-12 overflow-hidden relative">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(255,255,255,0.08),transparent_60%)]"></div>

          <div className="flex-1 w-full text-center lg:text-left relative z-10">
            <span className="inline-block text-xs font-medium text-background-50/80 bg-background-50/15 px-3 py-1 rounded-full mb-4 whitespace-nowrap">随时随地在手机阅读</span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">移动端追瓜更便捷</h2>
            <p className="text-sm md:text-base text-background-50/80 leading-relaxed max-w-md mx-auto lg:mx-0">
              支持在手机浏览器中访问，无需下载 App，即可随时随地追踪网红爆料事件最新瓜与热点争议。所有内容自动适配移动端，阅读体验流畅，吃瓜永不掉队。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mt-5">
              <button
                type="button"
                className="px-5 py-2.5 bg-background-50 hover:bg-background-100 text-primary-600 font-semibold text-sm rounded-md transition-all cursor-pointer whitespace-nowrap"
              >
                立即访问
              </button>
              <button
                type="button"
                className="px-5 py-2.5 bg-transparent hover:bg-background-50/10 text-background-50 font-medium text-sm rounded-md border border-background-50/30 transition-all cursor-pointer whitespace-nowrap"
              >
                了解更多
              </button>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center relative z-10">
            <div className="relative w-48 h-80 md:w-56 md:h-96 rounded-2xl overflow-hidden border-4 border-background-50/20">
              <img
                src="https://readdy.ai/api/search-image?query=Mobile%20phone%20mockup%20displaying%20Chinese%20news%20feed%20with%20warm%20crimson%20and%20amber%20color%20scheme%2C%20modern%20UI%20design%2C%20trending%20topic%20cards%2C%20clean%20layout%2C%20dark%20mode%20inspired%20warm%20tones%2C%20elegant%20smartphone%20presentation%2C%20professional%20product%20photography%2C%20soft%20lighting&width=560&height=960&seq=app-mobile-mockup&orientation=portrait"
                alt="网红爆料移动端界面展示"
                className="w-full h-full object-cover object-top"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  if (target.parentElement) target.parentElement.classList.add('hidden');
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}